



import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ECharts, EChartsOption, init } from 'echarts';
/**
 * @author guan
 * @description 共用图表组件 new Echarts 构建图表
 */
@Component({})
export default class InformationChart extends Vue {
    /** 预设颜色 */
    readonly colorList = ['#0497f8', '#49269a'];
    /** x轴参数 */
    readonly xAxisData = Array.apply(null, Array(12)).map((x, index) => `${index + 1}月`);
    /** 数据 */
    @Prop({
        default: () => [[1, 2, 4, 5, 6]],
    })
    data!: Array<Array<number | string>>;
    /**
     * @author guan
     * @description 创建图表series
     * @return EChartOption.Series[] 返回图表series
     */
    creatSeries(): EChartsOption['series'] | undefined {
        const name = ['去年', '今年'];
        const result: EChartsOption['series'] = this.data.map((x, index) => {
            return {
                data: x,
                name: name[index],
                type: 'line',
                lineStyle: {
                    color: this.colorList[index],
                },
                areaStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            {
                                offset: 0,
                                color: this.colorList[index], // 0% 处的颜色
                            },
                            {
                                offset: 1,
                                color: 'transparent', // 100% 处的颜色
                            },
                        ],
                        global: false, // 缺省为 false
                    },
                },
            };
        });
        return result;
    }
    /** title */
    @Prop({ default: () => '默认值' })
    title!: string;
    /**
     * @author guan
     * @description 获取option
     * @return void
     */
    CreatOption(): EChartsOption {
        return {
            title: {
                text: this.title,
                textStyle: {
                    fontSize: 14,
                },
                left: 'left',
                top: '10%',
            },
            legend: {},
            xAxis: {
                type: 'category',
                splitArea: {
                    show: false,
                },
                data: this.xAxisData,
            },
            yAxis: {
                type: 'value',
            },
            series: this.creatSeries(),
        };
    }
    /** 传入的容器高度 */
    @Prop({ default: () => '350px' })
    private defaultHeight!: string;
    /** 图表实例 */
    private chart!: ECharts;
    /**
     * @author guan
     * @description 监听option,option变化时更新图表
     * @return void
     */
    @Watch('data', { immediate: true, deep: true })
    onPersonChanged1(): void {
        if (this.chart) {
            const option = this.CreatOption();
            this.chart.setOption(option, true);
            // setTimeout(() => {
            //     this.chart.resize();
            // }, 500);
            this.chart.resize();
        }
    }
    /**
     * @author guan
     * @description 初始化图表
     * @return void
     */
    mounted(): void {
        /** 初始化 */
        this.chart = init(this.$el as HTMLDivElement);
        window.onresize = () => {
            this.chart.resize();
        };
        const option = this.CreatOption();
        this.chart.setOption(option);
        this.chart.resize();
    }
}
